// extracted by mini-css-extract-plugin
export default {"navbarDesign":"style_navbarDesign__FIIl4","navbarFeature":"style_navbarFeature__4Gk-7","modalmobilebutton":"style_modalmobilebutton__OXvZJ","navbarLogo":"style_navbarLogo__qgbC+"};